import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { MAIN_REQUEST_URL } from '../constants';
import { errorResponseManager } from '../utils';
import { store } from '../redux/ROOT';

// Base Url Prefix "/"
export const baseURL = `${MAIN_REQUEST_URL}`;

export const getBaseURL = (_port: any) => MAIN_REQUEST_URL;

// Config
const config: AxiosRequestConfig = {
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': "TR",
    'Kidly-Language': "TR",
    'Kidly-App-Version': "1.1",
    'Kidly-OS': "web",
  },
  timeout: 12000,
};

// Instance
const axiosInstance = axios.create(config);

//  Interceptor Request
axiosInstance.interceptors.request.use(async (config: AxiosRequestConfig) => {

  // const user={authentication:{token:""}};
  const { authentication } =  store.getState().authReducer;
  if (authentication && authentication.token && !config.headers?.Authorization) {

    config.headers = {
      ...config.headers,
      'Authorization': `Bearer ${authentication.token}`
    }
  }

  return config;
});

// on Ful Filled
const onFulFilled = async (response: AxiosResponse) => {
  return response.data;
};

// on Rejected
const onRejected = async (error: AxiosError) => {
  const { msg, status, data } = errorResponseManager(error);
  return Promise.reject({ msg, status, data });
};

//  Interceptor response
axiosInstance.interceptors.response.use(onFulFilled, onRejected);

export default axiosInstance;
